import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { u8aConcat } from '@polkadot/util';
import { Enum } from "../../codec/Enum.mjs";
import { Struct } from "../../codec/Struct.mjs";
import { EMPTY_U8A, IMMORTAL_ERA } from "../constants.mjs";
import { GenericExtrinsicPayloadV4 } from "./ExtrinsicPayload.mjs";
var FAKE_NONE = new Uint8Array();
var FAKE_SOME = new Uint8Array([1]);
/**
 * @name GenericExtrinsicSignatureV4
 * @description
 * A container for the [[Signature]] associated with a specific [[Extrinsic]]
 */

var _fakePrefix = _classPrivateFieldLooseKey("fakePrefix");

export var GenericExtrinsicSignatureV4 =
/*#__PURE__*/
function (_Struct) {
  _inherits(GenericExtrinsicSignatureV4, _Struct);

  function GenericExtrinsicSignatureV4(registry, value) {
    var _this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        isSigned = _ref.isSigned;

    _classCallCheck(this, GenericExtrinsicSignatureV4);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GenericExtrinsicSignatureV4).call(this, registry, _objectSpread({
      signer: 'Address',
      // eslint-disable-next-line sort-keys
      signature: 'ExtrinsicSignature'
    }, registry.getSignedExtensionTypes()), GenericExtrinsicSignatureV4.decodeExtrinsicSignature(value, isSigned)));
    Object.defineProperty(_assertThisInitialized(_this), _fakePrefix, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _fakePrefix)[_fakePrefix] = registry.createType('ExtrinsicSignature') instanceof Enum ? FAKE_SOME : FAKE_NONE;
    return _this;
  }
  /** @internal */


  _createClass(GenericExtrinsicSignatureV4, [{
    key: "_injectSignature",
    value: function _injectSignature(signer, signature, _ref2) {
      var era = _ref2.era,
          nonce = _ref2.nonce,
          tip = _ref2.tip;
      this.set('era', era);
      this.set('nonce', nonce);
      this.set('signer', signer);
      this.set('signature', signature);
      this.set('tip', tip);
      return this;
    }
    /**
     * @description Adds a raw signature
     */

  }, {
    key: "addSignature",
    value: function addSignature(signer, signature, payload) {
      return this._injectSignature(this.registry.createType('Address', signer), this.registry.createType('ExtrinsicSignature', signature), new GenericExtrinsicPayloadV4(this.registry, payload));
    }
    /**
     * @description Creates a payload from the supplied options
     */

  }, {
    key: "createPayload",
    value: function createPayload(method, _ref3) {
      var blockHash = _ref3.blockHash,
          era = _ref3.era,
          genesisHash = _ref3.genesisHash,
          nonce = _ref3.nonce,
          _ref3$runtimeVersion = _ref3.runtimeVersion,
          specVersion = _ref3$runtimeVersion.specVersion,
          transactionVersion = _ref3$runtimeVersion.transactionVersion,
          tip = _ref3.tip;
      return new GenericExtrinsicPayloadV4(this.registry, {
        blockHash: blockHash,
        era: era || IMMORTAL_ERA,
        genesisHash: genesisHash,
        method: method.toHex(),
        nonce: nonce,
        specVersion: specVersion,
        tip: tip || 0,
        transactionVersion: transactionVersion || 0
      });
    }
    /**
     * @description Generate a payload and applies the signature from a keypair
     */

  }, {
    key: "sign",
    value: function sign(method, account, options) {
      var signer = this.registry.createType('Address', account.addressRaw);
      var payload = this.createPayload(method, options);
      var signature = this.registry.createType('ExtrinsicSignature', payload.sign(account));
      return this._injectSignature(signer, signature, payload);
    }
    /**
     * @description Generate a payload and applies a fake signature
     */

  }, {
    key: "signFake",
    value: function signFake(method, address, options) {
      var signer = this.registry.createType('Address', address);
      var payload = this.createPayload(method, options);
      var signature = this.registry.createType('ExtrinsicSignature', u8aConcat(_classPrivateFieldLooseBase(this, _fakePrefix)[_fakePrefix], new Uint8Array(64).fill(0x42)));
      return this._injectSignature(signer, signature, payload);
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return this.isSigned ? _get(_getPrototypeOf(GenericExtrinsicSignatureV4.prototype), "toU8a", this).call(this, isBare) : EMPTY_U8A;
    }
  }, {
    key: "encodedLength",

    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get: function get() {
      return this.isSigned ? _get(_getPrototypeOf(GenericExtrinsicSignatureV4.prototype), "encodedLength", this) : 0;
    }
    /**
     * @description `true` if the signature is valid
     */

  }, {
    key: "isSigned",
    get: function get() {
      return !this.signature.isEmpty;
    }
    /**
     * @description The [[ExtrinsicEra]] (mortal or immortal) this signature applies to
     */

  }, {
    key: "era",
    get: function get() {
      return this.get('era');
    }
    /**
     * @description The [[Index]] for the signature
     */

  }, {
    key: "nonce",
    get: function get() {
      return this.get('nonce');
    }
    /**
     * @description The actual [[EcdsaSignature]], [[Ed25519Signature]] or [[Sr25519Signature]]
     */

  }, {
    key: "signature",
    get: function get() {
      // the second case here is when we don't have an enum signature, treat as raw
      return this.multiSignature.value || this.multiSignature;
    }
    /**
     * @description The raw [[ExtrinsicSignature]]
     */

  }, {
    key: "multiSignature",
    get: function get() {
      return this.get('signature');
    }
    /**
     * @description The [[Address]] that signed
     */

  }, {
    key: "signer",
    get: function get() {
      return this.get('signer');
    }
    /**
     * @description The [[Balance]] tip
     */

  }, {
    key: "tip",
    get: function get() {
      return this.get('tip');
    }
  }], [{
    key: "decodeExtrinsicSignature",
    value: function decodeExtrinsicSignature(value) {
      var isSigned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!value) {
        return EMPTY_U8A;
      } else if (value instanceof GenericExtrinsicSignatureV4) {
        return value;
      }

      return isSigned ? value : EMPTY_U8A;
    }
  }]);

  return GenericExtrinsicSignatureV4;
}(Struct);